import { PropsWithChildren, ReactNode } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type PanelProps = PropsWithChildren<
	WithClassName<{
		title: string
		icon: ReactNode
		action?: ReactNode
	}>
>

export const Panel = ({ title, icon, action, className, children }: PanelProps) => (
	<section className={cn('rounded-lg border border-border bg-card p-5 shadow-panel', className)}>
		<div className="mb-4 flex items-center gap-2.5">
			<span className="grid shrink-0 place-items-center text-muted-foreground [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-2">
				{icon}
			</span>
			<h2 className="font-display text-[15px] font-bold text-foreground">{title}</h2>
			{action && <div className="ml-auto">{action}</div>}
		</div>
		{children}
	</section>
)

export const PanelEmpty = ({ children }: PropsWithChildren) => (
	<p className="rounded-md border border-dashed border-border py-6 text-center text-[12px] text-muted-foreground">
		{children}
	</p>
)
